import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Card,
    CardTitle,
    Divider, CardContent, Button
} from '@chatui/core';
import './optionsCard.css'

function OperationCard(props) {
    const { t } = useTranslation();

    const defaultOptions = {
        [t('promotionOptions.category1', '在12POP上设置补贴或广告')]: [
            { label: t('promotionOptions.setupSubsidies', '设置补贴'), value: 'Set up Subsidies' },
            { label: t('promotionOptions.purchaseBanner', '购买横幅广告'), value: 'Purchase Banner' },
            { label: t('promotionOptions.purchaseSplash', '购买开屏广告'), value: 'Purchase Splash Advertisement' },
            { label: t('promotionOptions.improveRanking', '提升排名'), value: 'Improve Ranking' },
            { label: t('promotionOptions.joinSearchRecommendation', '加入搜索推荐'), value: 'Join Search Recommendation' },
        ],
        [t('promotionOptions.category2', '吸引顾客到您的店铺')]: [
            { label: t('promotionOptions.xiaohongshuPromotion', '小红书推广'), value: 'Xiaohongshu Promotion' },
            { label: t('promotionOptions.joiningDianping', '加入大众点评'), value: 'Joining Dianping' },
            { label: t('promotionOptions.improveGoogleMapRating', '提升谷歌地图评分'), value: 'Improve Google Map Rating' },
            { label: t('promotionOptions.setupGroupBuying', '设置团购'), value: 'Set up Groups Buying' },
        ],
    };

    const options = props.options ? props.options : defaultOptions;

    const onOptionClick = (item) => {
        if (props.onOptionClick) {
            // 传递 label（已翻译的文本）而不是 value
            props.onOptionClick(item.label);
        }
    };

    return (
        <Card fluid className={"options-card"}>
            <CardTitle>
                {props.title}
            </CardTitle>

            <CardContent className={"options"}>
                {Object.keys(options).map((category, index)=>(
                    <div key={index} className={"options-category"}>
                        <Divider></Divider>
                        <p>{(index+1)+'. '+ category}</p>
                        {options[category].map((item, item_idx)=>(
                            <Button
                                className={"option"}
                                style={{"margin": "3px"}}
                                key={item_idx}
                                label={item.label}
                                onClick={()=>onOptionClick(item)}
                            ></Button>
                        ))}
                    </div>
                ))}

            </CardContent>
        </Card>
    );
}

export default OperationCard;